import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { bootstrapAgGrid } from './ag-grid-bootstrap';

// TODO: We should pull out isemail library as it's meant for backend and remove this polyfill
import { Buffer } from 'buffer';
window.Buffer = Buffer; // Required for isemail

bootstrapAgGrid();

const root = createRoot(document.getElementById('root'));

// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );
root.render(<App />);
